import React from 'react'
import { Modal, ButtonToolbar, Button } from 'react-bootstrap'

import TourModalContainer from './modals/tourmodalcontent'

class TourModal extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.next = this.next.bind(this)
    this.prev = this.prev.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.state = {
      page: 1,
      show: this.props.show,

      PageOne:
        <span>
          <p>
            BrandWijzer is d&eacute; online applicatie voor inzicht in de brandveiligheid van uw zorginstelling. Na het invoeren van uw organisatorische eenheden (locaties en bijbehorende afdelingen of woongroepen) en medewerkers kunt u door middel van een scan vragen beantwoorden over de aanwezige risico&apos;s en maatregelen. U kunt eventueel medewerkers van de organisatorische eenheid via het systeem vragen voorleggen (&lsquo;raadplegen&rsquo;). Na het voltooien van de scan ziet u direct de resultaten.
          </p>
          <p>
            In dit scherm ziet u een overzicht van alle organisatorische eenheden die u in BrandWijzer heeft gezet en de totaalscore. Groen is boven de norm van brandveiligheid, rood is onder de norm van brandveiligheid. Het getal in het grijze vak zijn organisatorische eenheden die nog geen (voltooide) scan heeft.
          </p>
          <p>
            Overal in BrandWijzer staan i&apos;s in een grijs cirkeltje, dit zijn tooltips met extra toelichting of uitleg.
          </p>
        </span>,
      PageTwo:
        <span>
          <p>
            Start met het invoeren van uw locaties en organisatorische eenheden. Dit zijn kleine eenheden zoals een afdeling of woongroep die bij een locatie horen. U kunt ze handmatig een voor een invoeren, of u kunt ze importeren vanuit een Excel-bestand samen met de medewerkersgegevens. Download hiervoor het sjabloon, kopieer hier de locaties, eenheden en medewerkers en importeer dit bestand.
          </p>
          <p>
            Let erop dat u de namen van dezelfde locaties en organisatorische eenheden op dezelfde wijze schrijft!
          </p>
        </span>,
      PageThree:
        <span>
          <p>
            Hierna voert u de medewerkers van de organisatorische eenheden in. U hoeft alleen de medewerkers in te voeren die u mogelijk wilt raadplegen tijdens een scan. Een medewerker moet altijd gekoppeld zijn aan &eacute;&eacute;n organisatorische eenheid. Wilt u een medewerker bij meerdere eenheden raadplegen, dan moet u de medewerker dus voor elke organisatorische eenheid apart aanmaken.
          </p>
          <p>
            U kunt medewerkers handmatig een voor een invoeren, of u kunt ze importeren vanuit een Excel-bestand. Download hiervoor het sjabloon, kopieer hier de gegevens van de medewerker in en importeer dit bestand.
          </p>
        </span>,
      PageFour:
        <span>
          <p>
            Zodra u een organisatorische eenheid en te raadplegen medewerkers in BrandWijzer hebt gezet, kunt u een nieuwe scan uitvoeren. Kies bovenaan de bewuste locatie en organisatorische eenheid waarvan u een scan wilt verrichten.<br/>Hierna start u altijd met het beantwoorden van 2 &agrave; 3 vragen vooraf. Rechts in het scherm vinkt u de medewerkers aan die u mogelijk wilt raadplegen in deze scan. U h&oacute;eft uiteindelijk geen medewerkers te raadplegen en kunt per vraag altijd nog andere medewerkers aanvinken.
          </p>
          <p>
            Indien u de vragen vooraf heeft beantwoord en de te raadplegen medewerkers heeft aangevinkt, kunt u de scan starten.
          </p>
        </span>,
      PageFive:
        <span>
          <p>
            Een scan bestaat uit circa 25 meerkeuzevragen verdeeld over vier fasen van brand: Ontstaan van de brand, Brandontwikkeling &amp; rookverspreiding, Ontruiming en Continu&iuml;teit van zorg. U moet elke vraag beantwoorden. Indien u een vraag niet kunt beantwoorden of eerst medewerkers wilt raadplegen, zet u het grijze Raadpleeg-schuifje op groen. Deze vraag wordt dan geraadpleegd onder de geselecteerde medewerkers, u kunt de selectie per vraag wijzigen. Na het be&euml;indigen van de scan zullen de medewerkers een e-mail ontvangen om de vraag of vragen te beantwoorden.
          </p>
          <p>
            Onderaan de scan staat de optie om extra vragen aan medewerkers te stellen. Dit zijn vijf vragen die meer gaan over veiligheidsbeleving, gedrag en cultuur. De antwoorden op deze vragen tellen niet mee in de resultaten van de scan, maar de uitkomsten kunnen u meer inzicht geven in wat medewerkers van het beleid daadwerkelijk merken.
          </p>
          <p>
            Geraadpleegde vragen komen na beantwoording in de scan te staan. Aan de hand van dit &lsquo;advies&rsquo; moet u zelf alsnog alle vragen beantwoorden om de scan te kunnen voltooien.
          </p>
        </span>,
      PageSix:
        <span>
          <p>
            In dit scherm ziet u de scores van de (meest recente) scan van een organisatorische eenheid. De resultaten zeggen iets over het niveau van brandveiligheid op verschillende niveaus. Groene cijfers en metertjes scoren in meer of mindere mate &lsquo;voldoende&rsquo; brandveiligheid, rode cijfers en metertjes scoren onvoldoende. 
          </p>
          <p>
            U kunt deze resultaten delen met uw bestuur of een locatieverantwoordelijke door op &lsquo;Rapportage&rsquo; te klikken.
          </p>
        </span>,
      PageSeven:
        <span>
          <p>
            In dit scherm kunt u van een organisatorische eenheid de impact van antwoorden op de resultaten van een scan beoordelen. Links in het scherm ziet de scores van de scan. Klikt u op de totaalscore, de score van een stuurwielonderdeel of de score van een fase, dan ziet u rechts de vragen en antwoorden die tot die score leidden. Indien u een antwoord aanpast, ziet u in de scores wat het effect daarvan is. Dit geeft u inzicht in welke risico&apos;s er aangepakt moeten worden of welke maatregelen er genomen moeten worden om een acceptabel niveau van brandveiligheid te behalen.
          </p>
          <p>
            Aangepaste antwoorden zijn alleen voor analyse, ze vervangen de gegeven antwoorden niet.
          </p>
        </span>,
      PageEight:
        <span>
          <p>
            Dit scherm geeft een overzicht van alle scans die u in BrandWijzer heeft gedaan. U kunt vanaf hier naar de resultaten van elke voltooide scan, ook oudere scans. Hier kunt u eventueel ook alle ingevoerde data van alle scans downloaden in een .csv-bestand om deze in uw eigen software (bijvoorbeeld Excel) verder te analyseren.
          </p>
        </span>,
      PageNine:
        <span>
          <p>
            U kunt elk scherm dat u ziet eenvoudig printen door in de menubalk op Printen te klikken.
          </p>
        </span>,
      PageTen:
        <span>
          <p>
            Onder deze knop staan o.a. uw accountgegevens zoals u bij BrandWijzer bekend bent. Hier kunt u ook medebeheerders van BrandWijzer aanmaken. Onder deze knop vindt u ook meer informatie over BrandWijzer en de achterliggende rekenmethodes. Onder Rondleiding kunt u op elk gewenst moment de rondleiding die u nu volgt nog eens doorlopen.
          </p>
        </span>,
      PageEleven:
        <span>
          <p>
            U kunt BrandWijzer meer persoonlijk maken door het logo van uw organisatie toe te voegen.
          </p>
        </span>
    }
  }

  componentDidMount() {
    // Remove "active" from main-nav if upper level has "active" class
    this.currentPath = document.getElementById("navigation").querySelector('.active')
    if (this.currentPath) {
      this.currentClasses = this.currentPath.classList
      this.currentClasses.remove('active')
    }
  }

  next() {
    this.setState({
      page: this.state.page + 1
    })
  }

  prev() {
    this.setState({
      page: this.state.page - 1
    })
  }

  handleHide() {
    this.props.hideTourModal()
    this.setState({ show: this.props.show, page: 0 })

    // Remove "active"-classes
    document.body.classList.remove('tour-active')
    document.getElementById("navigation").getElementsByClassName("active").length > 0 && document.getElementById("navigation").getElementsByClassName("active")[0].classList.remove('active')

    // Re-set "active"-class to current main-nav item
    if (this.currentPath) {
      const currentClasses = this.currentClasses.add('active')
      document.getElementById("navigation").getElementsByClassName(currentClasses)
    }

    const value = document.cookie = "modaldone=true"

    if (this.props.selfTriggered === false) {
      this.props.sendData(value)
    }
  }

  render() {
    return (
      <div>
        <ButtonToolbar>
          <Modal
            {...this.props}
            show={this.props.show}
            onHide={this.handleHide}
            dialogClassName="tour">

            <Modal.Header closeButton>
            </Modal.Header>

            { this.state.page < 10 && document.body.classList.add('tour-active') }
            { this.state.page === 0 && document.body.classList.remove('tour-active') }
            { this.state.page === 1 && <TourModalContainer currentclass="tour-item-dashboard" previndicator="" currentindicator="dashboard" nextindicator="units" title="Welkom bij BrandWijzer" bodytext={this.state.PageOne} /> }
            { this.state.page === 2 && <TourModalContainer currentclass="tour-item-units" previndicator="dashboard" currentindicator="units" nextindicator="units" title="Organisatie" bodytext={this.state.PageTwo} /> }
            { this.state.page === 3 && <TourModalContainer currentclass="tour-item-units" previndicator="units" currentindicator="units" nextindicator="new-scan" title="Medewerkers" bodytext={this.state.PageThree} /> }
            { this.state.page === 4 && <TourModalContainer currentclass="tour-item-new-scan" previndicator="units" currentindicator="new-scan" nextindicator="new-scan" title="Nieuwe scan" bodytext={this.state.PageFour} /> }
            { this.state.page === 5 && <TourModalContainer currentclass="tour-item-new-scan" previndicator="results" currentindicator="new-scan" nextindicator="new-scan" title="Scan invullen" bodytext={this.state.PageFive} /> }
            { this.state.page === 6 && <TourModalContainer currentclass="tour-item-results" previndicator="new-scan" currentindicator="results" nextindicator="analysis" title="Resultaten" bodytext={this.state.PageSix} /> }
            { this.state.page === 7 && <TourModalContainer currentclass="tour-item-analysis" previndicator="results" currentindicator="analysis" nextindicator="scans" title="Analyse" bodytext={this.state.PageSeven} /> }
            { this.state.page === 8 && <TourModalContainer currentclass="tour-item-scans" previndicator="analysis" currentindicator="scans" nextindicator="account" title="Scans" bodytext={this.state.PageEight} /> }
            { this.state.page === 9 && <TourModalContainer currentclass="tour-item-account" previndicator="scans" currentindicator="account" nextindicator="" title="Account" bodytext={this.state.PageTen} /> }
            { this.state.page === 10 && <TourModalContainer currentclass="tour-item-logo" previndicator="account" currentindicator="" title="Logo" bodytext={this.state.PageEleven} /> }

            <Modal.Footer>
              { this.state.page > 1 && < Button className="prev" onClick={this.prev}>Vorige</Button> }
              { this.state.page < 10 && < Button className="next"  onClick={this.next}>Volgende</Button> }
              { this.state.page === 10 && < Button className="close-btn" id="close" onClick={this.handleHide}>Einde</Button> }
            </Modal.Footer>
          </Modal>
        </ButtonToolbar>
      </div>
    )
  }
}

export default TourModal



// WEBPACK FOOTER //
// ./src/pages/Tour/index.js